// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__d7cBK","info":"PatientInfo_info__uQnHo"};